jQuery($ => {    
    $.fn.getPage = function () {
      var page = 1;

      if ($(this).hasClass('m-pagination__page')) {
        page = parseInt($(this).text());
      } else {
        const currentPage = parseInt($('.m-pagination__page--active').text());
        if ($(this).hasClass('m-pagination__direction--right')) {
          page = currentPage + 1;
        } else if ($(this).hasClass('m-pagination__direction--left')) {
          page = currentPage - 1;
        }
      }
  
      return page;
    };

    function handleSubmit(page) {
      const form = $('.t-posts__form');
      const feed = $('.o-posts-feed');

      const pageInput = form.find('input[name="paged"]');
      if (pageInput[0] && page >= 1) {
        pageInput.val(page);
      }

      const searchInput = form.find('input[name="s"]');

      // If page > 1 or search input is not empty, hide featured posts
      if (page > 1 || searchInput.val().length > 0) {
        $('.o-featured-posts').addClass('o-featured-posts--hidden');
      } else {
        $('.o-featured-posts').removeClass('o-featured-posts--hidden');
      }

      // Get all fields from form
      let formData = form.serialize();

      formData += '&action=load_filtered_posts';
      formData += `&url=${window.location.href.replace(window.location.search, '')}`;

      feed.addClass('o-posts-feed--loading');

      // Push current feed html and url to history
      window.history.pushState(
        {
          feed: feed.html(),
        },
        {},
        window.location.href
      );

      $.ajax({
        type: 'POST',
        url: AJAX.url,
        data: formData,
        beforeSend: function() {
          AjaxRunning++;
        },
        success: function(result) {
          if (result.data.feed) {
            feed.html(result.data.feed);
          }

          if (result.data.url) {
            window.history.pushState(
              {
                feed: result.data.feed,
              },
              {},
              result.data.url
            );
          }

          const windowWidth = $(window).width();

          if (page || (windowWidth <= 768 && searchInput.val().length > 0)) {
            // If coming from pagination or if on mobile, scroll to top of feed
            const y = feed[0].getBoundingClientRect().top + window.scrollY + -180;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }

          $(window).trigger('ajax');
        },
        error: function(error) {
          console.error(error);
        },
        complete: function() {
          AjaxRunning--;
          feed.removeClass('o-posts-feed--loading');
        }
      })
    }

    var AjaxRunning = 0;

    // Initialize form handling
    if ($('.t-posts__form')[0]) {
      const form = $('.t-posts__form');

      form.on('submit', function(e) {
        if (form.attr('data-ajax') == 'true') {
          e.preventDefault();
          handleSubmit();
        }
      });
    }

    $(window).on('load ajax', function () {
      const form = $('.t-posts__form');
      form.find('input, select').on('change', function() {
        form.submit();
      });

      form.find('a[data-category]').on('click', function(e) {
        e.preventDefault();
        const category = $(this).data('category');
        form.find('input[name="category"]').val(category);
        form.submit();
      });
      
      $('.t-posts__form .m-pagination__page').click(function (e) {
        e.preventDefault();
        var page = $(this).getPage();
        handleSubmit(page);
      });

      $('.t-posts__form .m-pagination__direction').click(function (e) {
        e.preventDefault();
        var page = $(this).getPage();
        handleSubmit(page);
      });

      $()
    });

    if ($('.t-posts__form')[0]) {
      $(window).on('popstate', function (e) {
        if (e.originalEvent.state !== null) {
          if (e.originalEvent.state.feed) {
            $('.o-posts-feed').html(e.originalEvent.state.feed);
          }
        }
      });
    }
});